import { DatePicker as MuiDatePicker, DatePickerProps, PickersDay } from '@mui/x-date-pickers';
import {
  TextFieldProps as MuiTextFieldProps,
  IconButtonProps,
  styled,
  InputBaseComponentProps
} from '@mui/material';
import dayjs from 'dayjs';
import clsx from 'clsx';
import { IconButton } from '../../button/IconButton/IconButton';
import { Icon } from '../../icon/Icon';
import { TextField } from '../TextField/TextField';
import styles from './DatePicker.module.scss';

const StyledDay = styled(PickersDay)(() => ({
  fontSize: '12px'
}));

export function DatePicker({
  ...props
}: DatePickerProps<dayjs.Dayjs> & { dataId: string; textFieldProps?: InputBaseComponentProps }) {
  return (
    <MuiDatePicker
      {...props}
      referenceDate={dayjs()}
      slots={{ openPickerButton: calenderBtn, textField: DatePickerTextField, day: StyledDay }}
      slotProps={{
        textField: {
          className: clsx({ [styles.width115px]: props.disableOpenPicker }),
          inputProps: { dataId: props.dataId, ...(props.textFieldProps ?? {}) }
        }
      }}
    />
  );
}

const calenderBtn = (props: IconButtonProps) => {
  return (
    <IconButton dataId='date-picker' label='' className='mr-1' {...props}>
      <Icon name='date' size={3} />
    </IconButton>
  );
};

function DatePickerTextField(props: MuiTextFieldProps) {
  const { inputProps = {}, ...rest } = props;
  return (
    <TextField
      size='small'
      {...rest}
      inputProps={inputProps}
      dataId={inputProps?.dataId}
      uncontrolled
    />
  );
}
